import { gql } from '@apollo/client';

export const GET_ALL_PROGRAMS = gql`
  query GetAllPrograms {
    programs {
      id
      name
      description
    }
  }
`;
